import React from 'react'
import Grid from '@material-ui/core/Grid'

const PlaceInSection = ({ placeAt, setPlaceAt }) => {
  const handleOnChange = ({ target: { value } }) => setPlaceAt(value)

  return (
    <Grid item xs={12}>
      <Grid container className='w-100 b pa6'>
        <Grid item xs={3}>
          <label htmlFor='parentId'>Place at</label>
        </Grid>
        <Grid item xs={9} className='pl8'>
          <select name='placeAt' value={placeAt} onChange={handleOnChange} className='menu-list-button'>
            <option value='top'>Top</option>
            <option value='bottom'>Bottom</option>
          </select>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PlaceInSection
